import React, { Component } from "react";
import { connect } from 'react-redux'
import L from 'leaflet'
import { GeoJSON } from 'react-leaflet'
import Api_spatial from "../../../api/api.spatial";
import message from "../../Messages";
import typo, { MESSAGE } from "../../../constants/dictionaries";
import Helper from "../../../helper/helper";

class GeoJson_Layer extends Component {
    constructor(props) {
        super(props);
        const { functions } = props;
        this.state = {
            GeoJson_data: {
                data: null,
                style: null,
                key: null
            }
        }

    }



    componentDidMount() {
        const { dulieu, loai } = this.props
        if (loai === "DTM") {
            this.GetSpatialDTMDiem(dulieu.idtramquantrac)
        } else if (loai === "BVMT") {
            this.GetSpatialBVMTDiem(dulieu.idtramquantrac)
        } else if (loai === "NTTS") {
            this.GetSpatialNTTSDiem(dulieu.idtramquantrac)
        } else if (loai === "QDXP") {
            this.GetSpatialQDXPDiem(dulieu.idtramquantrac)
        } else if (loai === "HTMT") {
            this.GetSpatialHTMT(dulieu.idtramquantrac, dulieu.kyhieu)
        } else if (loai === "TNN") {
            this.GetSpatialTNNDiem(dulieu.idtramquantrac)
        } else if (loai === "VHL") {
            this.GetSpatialVHLDiem(dulieu.idtramquantrac)
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { dulieu, loai } = this.props
        if (prevProps.dulieu !== dulieu) {
            if (loai === "DTM") {
                this.GetSpatialDTMDiem(dulieu.idtramquantrac)
            } else if (loai === "BVMT") {
                this.GetSpatialBVMTDiem(dulieu.idtramquantrac)
            } else if (loai === "NTTS") {
                this.GetSpatialNTTSDiem(dulieu.idtramquantrac)
            } else if (loai === "QDXP") {
                this.GetSpatialQDXPDiem(dulieu.idtramquantrac)
            } else if (loai === "HTMT") {
                this.GetSpatialHTMT(dulieu.idtramquantrac, dulieu.kyhieu)
            } else if (loai === "TNN") {
                this.GetSpatialTNNDiem(dulieu.idtramquantrac)
            } else if (loai === "VHL") {
                this.GetSpatialVHLDiem(dulieu.idtramquantrac)
            }
        }
    }
    GetSpatialVHLDiem = (idvhl) => {
        const { zoomOut } = this.props
        new Api_spatial()
            .GetSpatialVHLDiem({
                token: this.props.user.access_token,
                idvhl: idvhl,
            })
            .then((res) => {
                if (res != null && res.result != null) {
                    const a = JSON.parse(res.result)
                    const newGeom = { newGeom: (delete a.geometry['crs'], a) };
                    const Json_newGeom = { ...newGeom.newGeom }
                    const b = JSON.stringify(Json_newGeom)
                    this.setState({
                        GeoJson_data: {
                            data: Json_newGeom,
                            key: b
                        }
                    })
                    var latlong = [a.geometry.coordinates[1], a.geometry.coordinates[0]]
                    zoomOut(latlong)
                } else {
                    this.setState({
                        GeoJson_data: {
                            data: null,
                            style: null,
                            key: null
                        }
                    })
                    message.warning(MESSAGE.CSCORE_KHONG_CO_DU_LIEU_BAN_DO);
                }
            })
            .catch((err) => {
                //message.error(err.message);
            });
    };
    GetSpatialTNNDiem = (idtnn_tqt) => {
        const { zoomOut } = this.props
        new Api_spatial()
            .GetSpatialTNNDiem({
                token: this.props.user.access_token,
                idtnn_tqt: idtnn_tqt,
            })
            .then((res) => {
                if (res != null && res.result != null) {
                    const a = JSON.parse(res.result)
                    const newGeom = { newGeom: (delete a.geometry['crs'], a) };
                    const Json_newGeom = { ...newGeom.newGeom }
                    const b = JSON.stringify(Json_newGeom)
                    this.setState({
                        GeoJson_data: {
                            data: Json_newGeom,
                            key: b
                        }
                    })
                    var latlong = [a.geometry.coordinates[1], a.geometry.coordinates[0]]
                    zoomOut(latlong)
                } else {
                    this.setState({
                        GeoJson_data: {
                            data: null,
                            style: null,
                            key: null
                        }
                    })
                    message.warning(MESSAGE.CSCORE_KHONG_CO_DU_LIEU_BAN_DO);
                }
            })
            .catch((err) => {
                //message.error(err.message);
            });
    };

    GetSpatialBVMTDiem = (idbvmt) => {
        const { zoomOut } = this.props
        new Api_spatial()
            .GetSpatialBVMTDiem({
                token: this.props.user.access_token,
                idbvmt: idbvmt,
            })
            .then((res) => {
                if (res != null && res.result != null) {
                    const a = JSON.parse(res.result)
                    const newGeom = { newGeom: (delete a.geometry['crs'], a) };
                    const Json_newGeom = { ...newGeom.newGeom }
                    const b = JSON.stringify(Json_newGeom)
                    this.setState({
                        GeoJson_data: {
                            data: Json_newGeom,
                            key: b
                        }
                    })
                    var latlong = [a.geometry.coordinates[1], a.geometry.coordinates[0]]
                    zoomOut(latlong)
                } else {
                    this.setState({
                        GeoJson_data: {
                            data: null,
                            style: null,
                            key: null
                        }
                    })
                    message.warning(MESSAGE.CSCORE_KHONG_CO_DU_LIEU_BAN_DO);
                }
            })
            .catch((err) => {
                //message.error(err.message);
            });
    };
    GetSpatialDTMDiem = (iddtm) => {
        const { zoomOut } = this.props
        new Api_spatial()
            .GetSpatialDTMDiem({
                token: this.props.user.access_token,
                iddtm: iddtm,
            })
            .then((res) => {
                if (res != null && res.result != null) {
                    const a = JSON.parse(res.result)
                    const newGeom = { newGeom: (delete a.geometry['crs'], a) };
                    const Json_newGeom = { ...newGeom.newGeom }
                    const b = JSON.stringify(Json_newGeom)
                    this.setState({
                        GeoJson_data: {
                            data: Json_newGeom,
                            key: b
                        }
                    })
                    var latlong = [a.geometry.coordinates[1], a.geometry.coordinates[0]]
                    zoomOut(latlong)
                } else {
                    this.setState({
                        GeoJson_data: {
                            data: null,
                            style: null,
                            key: null
                        }
                    })
                    message.warning(MESSAGE.CSCORE_KHONG_CO_DU_LIEU_BAN_DO);
                }
            })
            .catch((err) => {
                //message.error(err.message);
            });
    };
    GetSpatialNTTSDiem = (idntts) => {
        const { zoomOut } = this.props
        new Api_spatial()
            .GetSpatialNTTSDiem({
                token: this.props.user.access_token,
                idntts: idntts,
            })
            .then((res) => {
                if (res != null && res.result != null) {
                    const a = JSON.parse(res.result)
                    const newGeom = { newGeom: (delete a.geometry['crs'], a) };
                    const Json_newGeom = { ...newGeom.newGeom }
                    const b = JSON.stringify(Json_newGeom)
                    this.setState({
                        GeoJson_data: {
                            data: Json_newGeom,
                            key: b
                        }
                    })
                    var latlong = [a.geometry.coordinates[1], a.geometry.coordinates[0]]
                    zoomOut(latlong)
                } else {
                    this.setState({
                        GeoJson_data: {
                            data: null,
                            style: null,
                            key: null
                        }
                    })
                    message.warning(MESSAGE.CSCORE_KHONG_CO_DU_LIEU_BAN_DO);
                }
            })
            .catch((err) => {
                //message.error(err.message);
            });
    };
    GetSpatialQDXPDiem = (idqdxp) => {
        const { zoomOut } = this.props
        new Api_spatial()
            .GetSpatialQDXPDiem({
                token: this.props.user.access_token,
                idqdxp: idqdxp,
            })
            .then((res) => {
                if (res != null && res.result != null) {
                    const a = JSON.parse(res.result)
                    const newGeom = { newGeom: (delete a.geometry['crs'], a) };
                    const Json_newGeom = { ...newGeom.newGeom }
                    const b = JSON.stringify(Json_newGeom)
                    this.setState({
                        GeoJson_data: {
                            data: Json_newGeom,
                            key: b
                        }
                    })
                    var latlong = [a.geometry.coordinates[1], a.geometry.coordinates[0]]
                    zoomOut(latlong)
                } else {
                    this.setState({
                        GeoJson_data: {
                            data: null,
                            style: null,
                            key: null
                        }
                    })
                    message.warning(MESSAGE.CSCORE_KHONG_CO_DU_LIEU_BAN_DO);
                }
            })
            .catch((err) => {
                //message.error(err.message);
            });
    };
    GetSpatialHTMT = (iddiemquantrac, kyhieu) => {
        const { zoomOut } = this.props
        new Api_spatial()
            .GetSpatialHTMT({
                token: this.props.user.access_token,
                iddiemquantrac: iddiemquantrac,
                kyhieu: kyhieu
            })
            .then((res) => {
                if (res != null && res.result != null) {
                    const a = JSON.parse(res.result)
                    const newGeom = { newGeom: (delete a.geometry['crs'], a) };
                    const Json_newGeom = { ...newGeom.newGeom }
                    const b = JSON.stringify(Json_newGeom)
                    this.setState({
                        GeoJson_data: {
                            data: Json_newGeom,
                            key: b
                        }
                    })
                    var latlong = [a.geometry.coordinates[1], a.geometry.coordinates[0]]
                    zoomOut(latlong)
                } else {
                    this.setState({
                        GeoJson_data: {
                            data: null,
                            style: null,
                            key: null
                        }
                    })
                    message.warning(MESSAGE.CSCORE_KHONG_CO_DU_LIEU_BAN_DO);
                }
            })
            .catch((err) => {
                //message.error(err.message);
            });
    };

    render() {

        return (
            <div>
                {this.state.GeoJson_data.data != null &&
                    <GeoJSON ref="geojson" key={this.state.GeoJson_data.key} data={this.state.GeoJson_data.data} />
                }
            </div>

        );
    }
}
const mapStateToProps = (state) => ({
    user: state.oidc.user,
    functions: state.functions
});

export default connect(mapStateToProps)(GeoJson_Layer);

